import {EventConstants} from 'constants/EventConstants';
import {writeFragmentToCache} from 'graphql-client/ApolloWrappers';
import {getFragmentWrapper} from 'graphql-client/declarative-translations/external/getFragmentWrapper';
import AppDispatcher from 'lib/Dispatcher';
import notifications from 'notifications';
import {Thunk} from 'redux-stores/Store';
import doRequestTemplateQuery from 'requests/graphql/doRequestTemplateQuery';
import {getLegacyRequestObjectName} from 'requests/RequestConstants';
import {schemaSpecFetched, setSchemaSpecError} from 'schemas/spec/SchemaConfigReduxActions';
import getSpecError from 'ui-library/spec-editor/getSpecError';
import {withLoadingScreen} from 'util/Promises';

import {RequestTemplateGraphQL} from '../../../graphql-fragments/requests/__generated/RequestTemplateGraphQL';
import {RequestTemplateSpec} from './RequestTemplateConstants';
import * as RequestTemplateDAO from './RequestTemplateDAO';

function writeRequestTemplateToCache(template: RequestTemplateGraphQL): void {
  writeFragmentToCache(getFragmentWrapper('RequestTemplate'), template);
}

export async function createRequestTemplate(requestSchemaId: string): Promise<void> {
  const {requestSchema, templateGraphQL} = await RequestTemplateDAO.createRequestTemplate(requestSchemaId);
  AppDispatcher.dispatch({
    actionType: EventConstants.ASSAY_SCHEMA_FETCHED,
    assaySchema: requestSchema,
  });
  writeRequestTemplateToCache(templateGraphQL);
  notifications.success(`Created ${getLegacyRequestObjectName({lowerCase: true})} template successfully`);
}

export function updateRequestTemplateSpec(requestTemplateId: string, spec: RequestTemplateSpec): Thunk<void> {
  return async (dispatch) => {
    try {
      const {schemaSpec, templateGraphQL} = await withLoadingScreen(
        RequestTemplateDAO.updateRequestTemplate(requestTemplateId, spec),
        'Updating...'
      );
      dispatch(schemaSpecFetched(requestTemplateId, schemaSpec));
      writeRequestTemplateToCache(templateGraphQL);
      notifications.success('Updated request template successfully');
    } catch (error) {
      const specError = getSpecError(error);
      if (specError) {
        dispatch(setSchemaSpecError(specError));
      } else {
        throw error;
      }
    }
  };
}

export function fetchRequestTemplateSpec(requestTemplateId: string): Thunk<void> {
  return async (dispatch) => {
    const response = await doRequestTemplateQuery(requestTemplateId);
    if (response != null) {
      dispatch(schemaSpecFetched(requestTemplateId, response.templateSpecJson));
    }
  };
}
